/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import jwt_decode from "jwt-decode";

const SERVICE_NAME = "AppNavigatorService.AuthService";
const log: any = LoggerModule.getInstance();

export interface IAuthMethods extends IPluginMethodMap {
  getTokenSync(args: any): any;
}

export class AuthService implements IAgentPlugin {
  readonly methods: IAuthMethods;

  constructor() {
    this.methods = {
      getTokenSync: this.getToken.bind(this),
    };
  }

  getToken(args: any) {
    //TODO: FIX ME
    const storageService = StorageModule.getInstance();
    const localToken = storageService.get("userProfile", "local");
    const sessionToken = storageService.get("userProfile", "session");
    const token = localToken?.accessToken ?? sessionToken?.accessToken;
    // console.log(`token in service`, sessionToken);
    if (token) {
      const _validToken = this.getValidToken(token);
      return _validToken;
    } else {
      storageService.reset("local");
      storageService.reset("session");
      return null;
    }
  }

  private getValidToken(token: string) {
    let decodedToken: any = jwt_decode(token);
    let currentDate = new Date();

    if (decodedToken?.exp * 1000 > currentDate.getTime()) {
      return token;
    } else return null;
  }
}
